class CollectionTabs {
  constructor() {
    this.init();
  }

  init() {
    const tabsContainer = document.querySelector('.collection-tabs__container');
    const tabsList = document.querySelector('.collection-tabs__list');
    const prevArrow = document.querySelector('.collection-tabs__arrow--prev');
    const nextArrow = document.querySelector('.collection-tabs__arrow--next');
    
    if (!tabsContainer || !tabsList || !prevArrow || !nextArrow) return;

    this.tabsContainer = tabsContainer;
    this.tabsList = tabsList;
    this.prevArrow = prevArrow;
    this.nextArrow = nextArrow;
    this.currentScroll = 0;
    this.maxScroll = 0;

    // Touch/swipe variables
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.scrollLeft = 0;

    this.setupEventListeners();
    this.updateArrowVisibility();
    
    // Update on window resize
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.updateArrowVisibility();
      }, 100);
    });
  }

  setupEventListeners() {
    // Arrow button events
    this.prevArrow.addEventListener('click', () => {
      this.scroll('prev');
    });

    this.nextArrow.addEventListener('click', () => {
      this.scroll('next');
    });

    // Touch/swipe events
    this.tabsList.addEventListener('mousedown', (e) => this.startDragging(e));
    this.tabsList.addEventListener('touchstart', (e) => this.startDragging(e));
    
    this.tabsList.addEventListener('mousemove', (e) => this.drag(e));
    this.tabsList.addEventListener('touchmove', (e) => this.drag(e));
    
    this.tabsList.addEventListener('mouseup', () => this.stopDragging());
    this.tabsList.addEventListener('touchend', () => this.stopDragging());
    this.tabsList.addEventListener('mouseleave', () => this.stopDragging());
  }

  startDragging(e) {
    this.isDragging = true;
    this.tabsList.style.cursor = 'grabbing';
    this.tabsList.style.userSelect = 'none';
    
    if (e.type === 'mousedown') {
      this.startX = e.pageX - this.tabsList.offsetLeft;
    } else if (e.type === 'touchstart') {
      this.startX = e.touches[0].pageX - this.tabsList.offsetLeft;
    }
    
    this.scrollLeft = this.currentScroll;
  }

  drag(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    
    let x;
    if (e.type === 'mousemove') {
      x = e.pageX - this.tabsList.offsetLeft;
    } else if (e.type === 'touchmove') {
      x = e.touches[0].pageX - this.tabsList.offsetLeft;
    }
    
    const walk = (this.startX - x) * 1.5; // Scroll speed multiplier
    const newScroll = this.scrollLeft + walk;
    
    // Constrain scrolling
    this.currentScroll = Math.max(0, Math.min(this.maxScroll, newScroll));
    this.tabsList.style.transform = `translateX(-${this.currentScroll}px)`;
  }

  stopDragging() {
    this.isDragging = false;
    this.tabsList.style.cursor = 'grab';
    this.tabsList.style.removeProperty('user-select');
    this.updateArrowVisibility();
  }

  scroll(direction) {
    const containerWidth = this.tabsContainer.offsetWidth;
    const scrollAmount = containerWidth * 0.8; // Scroll 80% of container width

    if (direction === 'prev') {
      this.currentScroll = Math.max(0, this.currentScroll - scrollAmount);
    } else {
      this.currentScroll = Math.min(this.maxScroll, this.currentScroll + scrollAmount);
    }

    this.tabsList.style.transform = `translateX(-${this.currentScroll}px)`;
    this.updateArrowVisibility();
  }

  updateArrowVisibility() {
    const containerWidth = this.tabsContainer.offsetWidth;
    const listWidth = this.tabsList.scrollWidth;
    
    this.maxScroll = Math.max(0, listWidth - containerWidth);
    
    // Hide arrows if no scrolling is needed
    if (this.maxScroll <= 0) {
      this.prevArrow.style.display = 'none';
      this.nextArrow.style.display = 'none';
      return;
    }

    // Show arrows
    this.prevArrow.style.display = 'flex';
    this.nextArrow.style.display = 'flex';

    // Update arrow states
    this.prevArrow.disabled = this.currentScroll <= 0;
    this.nextArrow.disabled = this.currentScroll >= this.maxScroll;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionTabs();
});

// Also initialize for dynamic content
document.addEventListener('shopify:section:load', () => {
  new CollectionTabs();
}); 